import axios from "axios";
import fx from "money";
import Options from "@/options";

const excludeArr = ["USD", "EUR", "BTC", "GBP", "JPY"];

export default {
  namespaced: true,
  state: {
    fx: null,
    rates: {},
  },
  getters: {
    currencies(state) {
      return [
        ...excludeArr.map((key) => ({ label: key, symbol: key })),
        ...Object.keys(state.rates)
          .filter(
            (key) =>
              Options.currencies.findIndex((v) => v.symbol == key) > -1 &&
              excludeArr.indexOf(key) === -1
          )
          .map((key) => ({ label: key, symbol: key }))
          .sort((a, b) => a.label.localeCompare(b.label)),
      ];
    },
    convertToCurrency: (state, _getters, _rootState, rootGetters) => (
      valueInFrom,
      currencyTo = null,
      currencyFrom = "USD"
    ) => {
      const settingsCurrency = currencyTo || rootGetters["settings/currency"];
      if (settingsCurrency === currencyFrom) {
        return valueInFrom;
      } else if (settingsCurrency === "BTC" && currencyFrom === "USD") {
        return valueInFrom / rootGetters["coinmarketcap/priceOfBTC"];
      } else if (currencyFrom === "BTC" && settingsCurrency === "USD") {
        return valueInFrom * rootGetters["coinmarketcap/priceOfBTC"];
      } else if (settingsCurrency === "BTC") {
        return state
          .fx(valueInFrom)
          .from(currencyFrom)
          .to("USD") / rootGetters["coinmarketcap/priceOfBTC"];
      } else if (state.fx != null) {
        return state
          .fx(valueInFrom)
          .from(currencyFrom)
          .to(settingsCurrency);
      } else {
        return 0;
      }
    },
  },
  mutations: {
    setRates(state, rates) {
      state.fx = fx;
      state.rates = rates;
      state.fx.rates = rates;
      state.fx.base = "USD";
    },
  },
  actions: {
    async getCurrencyConversionRates({ commit }) {
      try {
        const {
          data: { rates },
        } = await axios.get(Options.currencyListUrl);
        commit("setRates", rates);
      } catch (err) {
        console.log(
          "Cointrackr was unable to get currency conversion rates.",
          err
        );
      }
    },
  },
};
